<script>
    export default {
        mounted: function () {
            this.$app.eventBus.$on('timezone-changed', this.loadData);
        },
        beforeDestroy: function () {
            this.$app.eventBus.$off('timezone-changed');
        },
        methods: {
            loadData: function () {
            }
        }
    }
</script>


// WEBPACK FOOTER //
// timezone-change.vue?d9f61188